"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.returnSendStatus = void 0;
var _configData = require("@/common/config-data");
var returnSendStatus = exports.returnSendStatus = function returnSendStatus(val) {
  return _configData.sendStatus[val] || '';
};